import React, { useEffect } from 'react';
import './Modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;  // childrenを追加
  width: string;
  height: string;
  contentClassName: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children,
  width, height, contentClassName}) => {
  
  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = "hidden"
      window.addEventListener('keydown', handleKeydown);
    }

    return () => {
      document.body.style.overflow = "auto"
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className={"modal-content " + contentClassName }
        style={{width:width, height:height}}>
        <button className="modal-close-button fancy-close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
